<div class="m-content">
  <div class="row">
    <div class="col-sm-12">
      <div class="m-portlet m-portlet--full-height">
        <div class="m-portlet__body">
          <div class="hx-filters">
            <div class="filter">
              <small>{{ 'income-outcome.shop' | transloco }}</small>
              <hx-store-select [(ngModel)]="params.storeId" (selectChange)="onStoreChanged($event)"></hx-store-select>
            </div>

            <div class="filter">
              <small>{{ 'income-outcome.date' | transloco }}</small>
              <hx-date-select [(ngModel)]="params.date" (selectChange)="navigate()"></hx-date-select>
            </div>

            <div class="filter">
              <small>{{ 'income-outcome.categories' | transloco }}</small>
              <hx-product-category-select [(ngModel)]="params.categoryIds" [default]="true" [multiple]="true"
                                          [brandId]="brandId"
                                          (selectChange)="navigate()"></hx-product-category-select>
            </div>
          </div>

          <button type="button" (click)="resetFilter()" class="btn btn-outline-primary m--margin-top-15">
            {{ 'reset.list' | transloco }}
          </button>

          <div class="m_datatable m-datatable--fixed-col m-datatable m-datatable--default m-datatable--loaded m--margin-top-30 m--margin-bottom-30 is--fixed-column">
            <table *ngIf="list.length && !isLoading.list" class="m-datatable__table m-datatable__table--width">
              <thead class="m-datatable__head">
                <tr class="m-datatable__row m-datatable__row--head">
                  <th class="m-datatable__cell m-datatable__cell--fixed-col" style="height: 40%;">
                    <span>{{ 'income-outcome.table.head.product' | transloco }}</span>
                  </th>
                  <th rowspan="2" class="m-datatable__cell">
                    <span>{{ 'income-outcome.table.head.remainder' | transloco }}<br>{{ 'income-outcome.table.head.beginningDay' | transloco }}</span>
                  </th>
                  <th colspan="6" class="m-datatable__cell text-center" *ngFor="let store of headers?.stores">
                    <span>{{ store.title | uiLabel }}</span>
                  </th>
                  <th rowspan="2" class="m-datatable__cell text-nowrap" *ngFor="let emp of headers?.employees">
                    <span [ngbTooltip]="emp.fullname">{{ emp.fullname | fio }}</span>
                  </th>
                  <th rowspan="2" class="m-datatable__cell m-datatable__cell--center">
                    <span>{{ 'income-outcome.table.head.remainder' | transloco }}<br>{{ 'income-outcome.table.head.endDay' | transloco }}</span>
                  </th>
                </tr>
                <tr class="m-datatable__row m-datatable__row--head">
                  <th></th>
                  <ng-container *ngFor="let store of headers?.stores">
                    <th class="m-datatable__cell">
                      <span>{{ 'income-outcome.table.head.coming' | transloco }}</span>
                    </th>
                    <th class="m-datatable__cell">
                      <span>{{ 'income-outcome.table.head.production' | transloco }}</span>
                    </th>
                    <th class="m-datatable__cell">
                      <span>{{ 'income-outcome.table.head.export' | transloco }}</span>
                    </th>
                    <th class="m-datatable__cell">
                      <span [title]="'income-outcome.writeOff' | transloco">{{ 'income-outcome.table.head.writeOff' | transloco }}</span>
                    </th>
                    <th class="m-datatable__cell">
                      <span [title]="'income-outcome.returnProduct' | transloco">{{ 'income-outcome.table.head.return' | transloco }}</span>
                    </th>
                    <th class="m-datatable__cell">
                      <span [title]="'income-outcome.inventory' | transloco">{{ 'income-outcome.table.head.inventory' | transloco }}</span>
                    </th>
                  </ng-container>
                </tr>
              </thead>
              <tbody class="m-datatable__body">
                <ng-container *ngFor="let even = even;let i = index; let productItem of list">
                  <tr class="m-datatable__row" [ngClass]="{ 'm-datatable__row--even': even }">
                    <th class="m-datatable__cell m-datatable__cell--fixed-col">
                      {{ productItem.productInfo?.title | uiLabel }} ({{ productItem.unitOfMeasure?.globalShortTitle | uiLabel }})
                    </th>
                    <td class="m-datatable__cell text-center">
                      {{ productItem.dayBeforeRemainder }}
                    </td>
                    <ng-container *ngIf="headers?.stores?.length">
                      <ng-container *ngFor="let store of headers?.stores">
                        <ng-container *ngFor="let curStore of productItem.stores">
                          <ng-container *ngIf="curStore.storeId === store.id">
                            <td class="m-datatable__cell text-center">{{ curStore.income }}</td>
                            <td class="m-datatable__cell text-center">{{ curStore.confectionaryAmount }}</td>
                            <td class="m-datatable__cell text-center">{{ curStore.exportAmount }}</td>
                            <td class="m-datatable__cell text-center">{{ curStore.discardedAmount }}</td>
                            <td class="m-datatable__cell text-center">{{ curStore.refundedAmount }}</td>
                            <td class="m-datatable__cell text-center">{{ curStore.inventoryAmount }}</td>
                          </ng-container>
                        </ng-container>
                      </ng-container>
                    </ng-container>

                    <ng-container *ngIf="headers?.employees?.length">
                      <td class="m-datatable__cell" *ngFor="let emp of headers?.employees">
                        <ng-container *ngFor="let curEmployer of productItem.employees">
                          <span *ngIf="curEmployer.userId === emp.id">
                            <span>{{ curEmployer.deliveryAmount }}</span>
                          </span>
                        </ng-container>
                      </td>
                    </ng-container>
                    <td [ngbTooltip]="(isDayRemainderValid(productItem.productInfo?.id, productItem.selectedDayRemainder) ?  'projects-outcome.remainder' : 'projects-outcome.wrongBalance') | transloco"
                        [ngClass]="isDayRemainderValid(productItem.productInfo?.id, productItem.selectedDayRemainder) ? 'm-datatable__cell text-center' : 'm-datatable__cell--red'">
                      {{ productItem.selectedDayRemainder }}
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>

            <hx-loader [length]="list.length" [isLoading]="isLoading.list"></hx-loader>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
